import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: 'deleteOrder',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteOrder($ids: [String]!) {
        deleteOrder(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
